import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_107_add_inspection: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Add inspection",
    style: {
      // backgroundColor: "#F1F8E9",
    },
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "vehicle_in",
        columnNumber: "m1 t1 w1",
        TableName: "vehicle_in",
        DisplayName: "Inspection in",
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        // Note: childComponents can have Fields property
        // Components within childComponents can define their fields using Fields
        Fields: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [
              {
                componentType: ComponentType.BUTTON,
                name: "Edit",
                Label: "Edit",
                BindValue: "btn_Edit",
                onPressAction: "edit",
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  marginBottom: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "lock",
                Label: "lock",
                BindValue: "lock",
                onPressAction: "unlock",
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  marginBottom: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
              {
                componentType: ComponentType.BUTTON,
                name: "Print",
                Label: "Print",
                BindValue: "btn_Print",
                onPressAction: "pdf_inspection",
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  marginBottom: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
            ],
          },
          {
            componentType: LayoutTypes.FIELD_GROUP as any,
            orientation: "row",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                IncludeLabel: true,
                Label: "VIN No.",
                PlaceHolder: "Will be auto generated...",
                IsMandatory: false,
                BindValue: "vin_number",
                Json_Attribute: "vin_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                AutoPopulate: true,
                AutoPopulate_format: "VIN_[******]",
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "VIN date",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "vin_date",
                Json_Attribute: "vin_date",
                IsReadOnly: false,
                componentType: ComponentType.DATETIME_FIELD,
                showInSummary: true,
                IsVerticalView: true,
                DefaultToday: true,
                maxDate: "today",
              },
              {
                IncludeLabel: true,
                Label: "Reg No.",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "drp_veh_reg_no",
                Json_Attribute: "vehicle_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                PopupScreenId: "102",
                showInSummary: false,
                LookupName: "vehicle_no",
                IsVerticalView: true,
                BindScreen: {
                  EnableAdding: true,
                  BindScreen: "vehicle_add_from_modal",
                },
              },
              {
                IncludeLabel: true,
                Label: "Vehicle make",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_vehicle_make",
                Json_Attribute: "vehicle_make",
                IsReadOnly: true,
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                BindParent: {
                  drp_veh_reg_no: "vmake",
                },
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Vehicle type",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_vehicle_type",
                Json_Attribute: "vehicle_type",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                BindParent: {
                  drp_veh_reg_no: "vehicletype",
                },
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Vehicle model",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_vehicle_model",
                Json_Attribute: "vehicle_model",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                BindParent: {
                  drp_veh_reg_no: "model",
                },
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Customer name",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_customer_name",
                Json_Attribute: "customer_name",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsReadOnly: true,
                BindParent: {
                  drp_veh_reg_no: "customerid"
                },
                IsVerticalView: true,
                inputType: InputType.TEXT
              },
              {
                IncludeLabel: true,
                Label: "Engine number",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_engine_number",
                Json_Attribute: "vehicle_eng_no",
                componentType: ComponentType.TEXT_FIELD,
                IsReadOnly: true,
                showInSummary: true,
                BindParent: {
                  drp_veh_reg_no: "engine_no",
                },
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Chassis No.",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_chasis_number",
                Json_Attribute: "vehicle_chas_no",
                componentType: ComponentType.TEXT_FIELD,
                IsReadOnly: true,
                showInSummary: true,
                BindParent: {
                  drp_veh_reg_no: "chasis_no",
                },
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "KM",
                PlaceHolder: "",
                IsMandatory: true,
                BindValue: "txt_km",
                Json_Attribute: "km",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                validation: [
                  {
                    rule: ValidationRule.PATTERN,
                    value: "^[0-9]*$",
                    message: "Invalid KM",
                  },
                ]
              },
              {
                IncludeLabel: true,
                Label: "Job category",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "drp_job_category",
                Json_Attribute: "job_category_id",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: true,
                LookupName: "job_category",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Salesman",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "drp_salesman",
                Json_Attribute: "salesman_id",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: true,
                LookupName: "salesman_union",
                PopupScreenId: "122",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Service advisor",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "drp_service_advisor",
                Json_Attribute: "service_advisor_id",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: true,
                LookupName: "service_advisor",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Fuel level",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "drp_fuel_level",
                Json_Attribute: "fuel_level",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: false,
                LookupName: "fuel_level",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Driver name",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_driver_name",
                Json_Attribute: "driver_name",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsVerticalView: true,
                inputType: InputType.TEXT,
                validation: [
                  {
                    rule: ValidationRule.PATTERN,
                    value: "^[A-Za-z ]+$",
                    message: "Only alphabets and spaces are allowed",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Driver mobile",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_driver_mobile",
                Json_Attribute: "drive_mobile",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsVerticalView: true,
                required: false,
                inputType: InputType.TEXT,
                validation: [
                  {
                    rule: ValidationRule.PATTERN,
                    value: "^[0-9]+$",
                    message: "mobile number should be valid",
                  },
                ],
              },
              {
                IncludeLabel: true,
                Label: "Remarks",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_Remarks",
                Json_Attribute: "remarks",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
              {
                IncludeLabel: true,
                Label: "Delivery date",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "dt_del",
                Json_Attribute: "del_time",
                componentType: ComponentType.DATETIME_FIELD,
                showInSummary: false,
                IsVerticalView: true,
                DefaultToday: true,
                minDate: "today",
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            Label: "Customer verbatim",
            TableName: "service_cust_verbatim",
            Name: "service_cust_verbatim",
            BindValue: "sub_Checklist",
            DisableAddNewRow: true,
            childControls: [
              {
                IncludeLabel: true,
                Label: "Remarks",
                PlaceHolder: "Enter remarks here...",
                IsMandatory: false,
                BindValue: "txt_remarks1",
                Json_Attribute: "remarks",
                componentType: ComponentType.TEXT_FIELD,
              },
              // {
              //   IncludeLabel: true,
              //   Label: "Service advisor",
              //   PlaceHolder: "",
              //   IsMandatory: false,
              //   BindValue: "drp_service_advisor_sub",
              //   Json_Attribute: "service_advisor_id",
              //   componentType: ComponentType.SELECT_DROPDOWN,
              //   showInSummary: true,
              //   LookupName: "service_advisor",
              //   IsVerticalView: true,
              // },
            ],
          },
          {
            componentType: ComponentType.MULTI_SUB_LIST,
            Label: "Inspection items",
            TableName: "vehicle_in_checklist",
            Name: "vehicle_in_checklist",
            BindValue: "multi_Checklist",
            LookupName: "inpection_items",
            childComponents: [
              {
                IncludeLabel: true,
                Label: "SL No.",
                InputValue: "<SLNO>",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "lbl_sl",
                Json_Attribute: "sl_no",
                componentType: ComponentType.TEXT_FIELD,
              },
              {
                IncludeLabel: true,
                Label: "Inspection items",
                InputValue: "<name>",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "lbl_inspection_items",
                Json_Attribute: "inspection_item",
                componentType: ComponentType.TEXT_FIELD,
              },
              {
                IncludeLabel: true,
                Label: "Attention",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "Chk_A",
                Json_Attribute: "checked_a",
                componentType: ComponentType.RADIO_FIELD,
              },
              {
                IncludeLabel: true,
                Label: "Caution",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "Chk_B",
                Json_Attribute: "checked_b",
                componentType: ComponentType.RADIO_FIELD,
              },
              {
                IncludeLabel: true,
                Label: "Satisfaction ",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "Chk_C",
                Json_Attribute: "checked_c",
                componentType: ComponentType.RADIO_FIELD,
              },
            ],
          },
          {
            IncludeLabel: true,
            Label: "Work requested",
            PlaceHolder: "",
            TableName: "vehicle_work_requested",
            Name: "vehiclein_work_requested",
            IsMandatory: false,
            BindValue: "multi_work_request",
            Json_Attribute: "work_requested_id",
            componentType: ComponentType.MULTI_CHECKBOX,
            LookupName: "work_request",
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Save",
        onPressAction: "save",
        style: {
          backgroundColor: "var(--primary-green)",
        },
      },
    ],
  },
];
